import { Dd } from './Dropdown.js';

/**
 * ehr#708 (Jay 10-30, Q2): a discharge summary for a client with no treatment plan on file signs
 * with a reason, picked from the practice's list (Assessment only, Left before plan completed,
 * Single session/crisis, Transferred out, and any the practice added in Note settings). A reason
 * saved before it was taken off the list still shows.
 */
export function NoPlanReasonField({
  value,
  reasons,
  locked,
  onChange,
}: {
  value: string;
  reasons: readonly string[];
  locked: boolean;
  onChange: (v: string) => void;
}) {
  const list = value && !reasons.includes(value) ? [...reasons, value] : [...reasons];
  return (
    <div className="pn-noplan pn-noplan-reason" data-test="noplan-reason">
      <b>No treatment plan on file</b>
      <div className="pn-sd-f">
        <span>Reason</span>
        <Dd
          value={value}
          options={list.map((r) => ({ value: r, label: r }))}
          onChange={onChange}
          placeholder="Pick a reason"
          searchable={list.length > 8}
          ariaLabel="No treatment plan on file reason"
          disabled={locked}
        />
      </div>
    </div>
  );
}
